import LoadStatus from "./LoadStatus";

export default LoadStatus;